import { PayloadFieldType, TreeNode } from './TypeDefs';

const isUnionWithArray = (fieldType: unknown[]): boolean =>
  fieldType.some((t) => typeof t !== 'string' && (t as PayloadFieldType).type === 'array');

export const extract = (field: PayloadFieldType, flattenedFields: string[], prefix: string[], result: TreeNode[], arrayFields: string[] = []) => {
  const fieldName = field.name;
  const fieldType = field.type;

  if (fieldType === 'array') {
    return;
  }

  if (Array.isArray(fieldType)) {
    const node: TreeNode = {
      label: fieldName,
      value: [...prefix, fieldName].join('.'),
    };
    flattenedFields.push(node.value);

    if (isUnionWithArray(fieldType)) {
      arrayFields.push(node.value);
      const parentPath = prefix.join('.');
      if (parentPath && !arrayFields.includes(parentPath)) {
        arrayFields.push(parentPath);
      }
    }

    if (fieldType.reduce((prevValue, type) => prevValue && typeof type === 'string', true)) {
      result.push(node);
    } else {
      node.children = extractPayloadFields(fieldType, flattenedFields, [...prefix, fieldName], arrayFields);
      result.push(node);
    }
  } else if (typeof fieldType === 'string' && fieldType !== 'record') {
    const node: TreeNode = {
      label: fieldName,
      value: [...prefix, fieldName].join('.'),
    };
    flattenedFields.push(node.value);
    result.push(node);
  } else if (field.fields && Array.isArray(field.fields)) {
    const node: TreeNode = {
      label: fieldName,
      value: prefix.join('.'),
    };
    flattenedFields.push(node.value);
    node.children = extractPayloadFields(field.fields, flattenedFields, prefix, arrayFields);
    result.push(node);
  } else if (fieldType && (fieldType as PayloadFieldType).fields && Array.isArray((fieldType as PayloadFieldType).fields)) {
    const node: TreeNode = {
      label: fieldName,
      value: [...prefix, fieldName].join('.'),
    };
    flattenedFields.push(node.value);
    node.children = extractPayloadFields((fieldType as PayloadFieldType).fields as PayloadFieldType[], flattenedFields, [...prefix, fieldName], arrayFields);
    result.push(node);
  } else if (fieldType && (fieldType as PayloadFieldType).type !== 'record') {
    const node: TreeNode = {
      label: fieldName,
      value: [...prefix, fieldName].join('.'),
    };
    flattenedFields.push(node.value);
    node.children = extractPayloadFields(fieldType as PayloadFieldType, flattenedFields, [...prefix, fieldName], arrayFields);
    result.push(node);
  }
};

/**
  * @method extractPayloadFields
  * @description extracts the nested payload field from an object with prefix attached to them
  * @param fields
  * @param prefix
  * @param arrayFields collects dot-paths of fields whose schema type is array
  * @returns result array containing field names
  */
export const extractPayloadFields = (fields: PayloadFieldType[] | PayloadFieldType, flattenedFields: string[] = [], prefix: string[] = [], arrayFields: string[] = []): TreeNode[] => {
  const result: TreeNode[] = [];

  if (Array.isArray(fields)) {
    fields.forEach((field: PayloadFieldType) => {
      extract(field, flattenedFields, prefix, result, arrayFields);
    });
  } else {
    extract(fields, flattenedFields, prefix, result, arrayFields);
  }
  return result;
};
